import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import type * as React from 'react'

interface OrderDetailButtonProps {
  onClick: () => void
  children?: React.ReactNode
}

/**
 * A button component for triggering order detail views
 */
export function OrderDetailButton({ onClick, children }: OrderDetailButtonProps) {
  return (
    <GraviButton onClick={onClick} icon={<MaterialIcon className='pt-1' icon='top_panel_close' />} size='small'>
      {children}
    </GraviButton>
  )
}
